import { ComputerBased } from "./form/computer-based";
import { ExamDate } from "./form/exam-date";
import { EnrollmentDeadline } from "./form/enrollment-deadline";
import { Oral } from "./form/oral";
export class ExamDetail {
    constructor(certificateId, examId, onDetailRemoved, examDetailWrapper) {
        this.certificateId = certificateId;
        this.examId = examId;
        this.onDetailRemoved = onDetailRemoved;
        this.inputHandlers = [];
        this.examDetailWrapper = examDetailWrapper;
        const element = this.createRow();
        this.addRemoveListener(element);
        this.examDetailWrapper.appendChild(element);
        this.inputHandlers.push(new ComputerBased(element), new ExamDate(element), new EnrollmentDeadline(element), new Oral(element));
    }
    addRemoveListener(element) {
        const buttonRemove = element.querySelector(ExamDetail.removeDetailSelector);
        buttonRemove.addEventListener("click", () => {
            element.parentElement.removeChild(element);
            this.onDetailRemoved(this);
        });
    }
    remplaceValues(element) {
        element.innerHTML = element.innerHTML
            .replace(/%examId%/g, this.examId)
            .replace(/%certificateId%/g, this.certificateId);
    }
    createRow() {
        const template = document.getElementById(ExamDetail.templateId);
        const row = this.findRowInTemplate(template);
        this.remplaceValues(row);
        return row;
    }
    findRowInTemplate(template) {
        let row = undefined;
        template.content.childNodes.forEach((child) => {
            if (child instanceof HTMLElement &&
                child.matches(ExamDetail.detailRowSelector)) {
                row = child;
            }
        });
        if (row === undefined) {
            throw new Error("Row not found in template");
        }
        return document.importNode(row, true);
    }
    addToFormData(formData) {
        this.inputHandlers.forEach((handler) => handler.addToFormData(formData));
    }
    validate() {
        return this.inputHandlers.every((handler) => handler.validate());
    }
}
ExamDetail.templateId = "exam-detail-session";
ExamDetail.removeDetailSelector = ".js-remove-detail";
ExamDetail.detailRowSelector = ".js-detail-row";
